import { axios } from 'lib/axios';

export const loginWithEmailAndPassword = (data) => {
  return axios.post('/accounts/login-pin', data);
};
